import "../App.css";
import { Box, Grid } from "@material-ui/core";
import React, { useState, useEffect } from "react";
import { useParams, Redirect } from "react-router-dom";
import { Question } from "../components/Question";
import * as AuthenticationUtil from "../util/AuthenticationUtil";

import { Paper, Button } from "@material-ui/core";

import { Copyright } from "../components/Copyright";

import * as Endpoints from "../util/Endpoints";
import * as ApiUtil from "../util/ApiUtil";
import { usePageLoader } from "../util/usePageLoader";
import { useAlert } from "../util/useAlert";

import { Logout } from "../components/Logout";
import { VaccineHistory } from "../components/VaccineHistory";
import { centeredPaperStyle, useActionButtonStyles } from "../components/ConsentDocumentBody";

import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
} from "@material-ui/core";

const dialogPaperProps = {
  style: { maxWidth: "min(560px, calc(100% - 32px))", margin: 16 },
};

export const QuestionPage = (props) => {
  const actionButtonClasses = useActionButtonStyles();
  const { questionnaireId } = useParams();
  const { groupQuestionnaireId } = useParams();

  const apiQuestion = `${Endpoints.unansweredQuestionByQuestionnaire}?questionnaireId=${questionnaireId}&groupQuestionnaireId=${groupQuestionnaireId}`;

  const [answers, setAnswers] = useState([]);

  const [response, setResponse] = useState({});
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [currentQuestionAnswer, setCurrentQuestionAnswer] = useState({});

  //const [proceedToNextQuestionnaire, setProceedToNextQuestionnaire] = useState(false);
  const [doneAnswering, setDoneAnswering] = useState(false);

  const [thankYouText, setThankYouText] = useState();

  const [loader, showLoader, hideLoader] = usePageLoader();
  const [alert, showAlert] = useAlert();

  const [open, setOpen] = useState(false);
  const [openThankYou, setOpenThankYou] = useState(false);

  const saveAnswer = (answerData) => {
    console.log(answers);
    console.log(answerData);
    updateAnswerState(answerData);
  };

  const updateAnswerState = (newAnswerData) => {
    let shouldAppend = false;
    let answersBackup = answers;
    for (let i = 0; i < answersBackup.length; i++) {
      if (answersBackup[i].questionId === newAnswerData.questionId) {
        if (newAnswerData.answer) {
          answersBackup[i].answer = newAnswerData.answer;
        } else {
          answersBackup[i].answerOptions = newAnswerData.answerOptions;
        }
        shouldAppend = true;
        break;
      }
    }
    if (!shouldAppend) {
      answersBackup.push(newAnswerData);
    }
    setAnswers(answersBackup);
    updateCurrentQuestionAnswer(currentQuestionIndex);
    console.log(currentQuestionAnswer);
  };

  const updateCurrentQuestionAnswer = (index) => {
    let currentAnswerUpdated = false;
    let answersBackup = answers;
    for (let i = 0; i < answersBackup.length; i++) {
      if (answersBackup[i].questionId === response.data.list[index].id) {
        setCurrentQuestionAnswer(answersBackup[i]);
        currentAnswerUpdated = true;
        break;
      }
    }
    if (!currentAnswerUpdated) {
      setCurrentQuestionAnswer({});
    }
  };

  useEffect(() => {
    getQuestion();
  }, []);

  // if (proceedToNextQuestionnaire && localStorage.getItem("current_group") === "NeedToAskFirst") {
  //     return <Redirect to="/next_questionnaire" />
  // }

  if (doneAnswering) {
    return <Redirect to="/questionnaire" />;
  }

  const getQuestion = async () => {
    try {
      showLoader();
      const responseData = await ApiUtil.callBackend(apiQuestion, "GET");
      console.log(responseData);

      setResponse(responseData);

      if (!responseData.status) {
        showAlert(responseData.message, "error");
      }
    } catch (error) {
      console.log(error);
      showAlert(error.message, "error");
    } finally {
      hideLoader();
    }
  };

  if (!AuthenticationUtil.isAuthenticated()) {
    return <Redirect to="/login" />;
  }

  const handleNavigatePrevious = () => {
    if (currentQuestionIndex - 1 < 0) {
      showAlert("No more questions.", "error");
    } else {
      setCurrentQuestionIndex(currentQuestionIndex - 1);
      updateCurrentQuestionAnswer(currentQuestionIndex - 1);
    }
  };

  // const handleNavigateNext = async (e) => {
  //     if (currentQuestionIndex + 1 < response.data.list.length) {
  //         setCurrentQuestionIndex(currentQuestionIndex + 1);
  //         updateCurrentQuestionAnswer(currentQuestionIndex + 1);
  //     } else if (answers.length > 0) {
  //         setOpen(true);
  //     } else {
  //         showAlert("Vänligen svara på frågorna", "error");
  //     }
  // }

  ///////////////////////2.
  //   const handleNavigateNext = async (e) => {
  //     if (currentQuestionIndex + 1 < response.data.list.length) {
  //       if (answers.length != currentQuestionIndex) {
  //         showAlert("Vänligen svara på frågorna", "error");
  //       } else {
  //         setCurrentQuestionIndex(currentQuestionIndex + 1);
  //         updateCurrentQuestionAnswer(currentQuestionIndex + 1);
  //       }
  //     } else if ((answers.length = currentQuestionIndex)) {
  //       setOpen(true);
  //     } else {
  //       showAlert("Vänligen svara på frågorna", "error");
  //     }
  //   };
  //   const handleNavigateNext = async (e) => {
  //     console.log(answers.length, " length ", currentQuestionIndex, " current ");
  //     if (currentQuestionIndex != answers.length || answers.length == 0) {
  //       showAlert("Vänligen svara på frågorna", "error");
  //     } else if (currentQuestionIndex + 1 < response.data.list.length) {
  //       setCurrentQuestionIndex(currentQuestionIndex + 1);
  //       updateCurrentQuestionAnswer(currentQuestionIndex + 1);
  //     } else if (answers.length > 0) {
  //       setOpen(true);
  //     } else {
  //       showAlert("Vänligen svara på frågorna", "error");
  //     }
  //   };
  const handleNavigateNext = async (e) => {
    console.log(answers.length, " length ", currentQuestionIndex, " current ");
    if (currentQuestionIndex == 0 && answers.length == 0) {
      //No answer selected (first time)
      showAlert("Vänligen svara på frågan", "error");
    } else if (
      answers.length != currentQuestionIndex + 1 &&
      !(answers.length > currentQuestionIndex + 1)
    ) {
      //No answer selected (first time onward)
      //No answer selected (first time onward)
      showAlert("Vänligen svara på frågan", "error");
    } else if (currentQuestionIndex + 1 < response.data.list.length) {
      setCurrentQuestionIndex(currentQuestionIndex + 1);
      updateCurrentQuestionAnswer(currentQuestionIndex + 1);
    } else if (answers.length > 0) {
      setOpen(true);
    } else {
      showAlert("Vänligen svara på frågan", "error");
    }
  };
  const submitAnswer = async () => {
    //Save answer
    try {
      showLoader();
      let answerRequestBody = {
        groupQuestionnaireId: groupQuestionnaireId,
        answers: answers,
      };
      let finishAnswerRequestBody = {
        groupQuestionnaireId: groupQuestionnaireId,
      };
      console.log(answerRequestBody);
      const responseData = await ApiUtil.callBackend(
        Endpoints.saveAnswer,
        "POST",
        answerRequestBody
      );
      const finishSurvey = await ApiUtil.callBackend(
        Endpoints.finishAnswer,
        "POST",
        finishAnswerRequestBody
      );
      console.log(responseData);

      if (responseData.status && finishSurvey.status) {
        //setProceedToNextQuestionnaire(false);
        //await eligible();
        //if (!proceedToNextQuestionnaire) {
        //setDoneAnswering(true);
        await getThankYouText();
        //}
        //getQuestion();
      } else {
        showAlert(responseData.message, "error");
      }
    } catch (error) {
      console.log(error);
      showAlert(error.message, "error");
    } finally {
      hideLoader();
      setOpen(false);
    }
  };

  const getThankYouText = async () => {
    try {
      showLoader();
      const responseData = await ApiUtil.callBackend(
        Endpoints.welcomeThankYouText,
        "GET"
      );
      console.log(responseData);

      setResponse(responseData);

      if (!responseData.status) {
        showAlert(responseData.message, "error");
      }
      setThankYouText(responseData.data.welcome.thankYouTextSwedish);
      setOpenThankYou(true);
    } catch (error) {
      console.log(error);
      showAlert(error.message, "error");
    } finally {
      hideLoader();
    }
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleCloseThankYou = () => {
    setOpenThankYou(false);
    setDoneAnswering(true);
  };

  // const eligible = async () => {
  //     let eligibleForFurtherQuestions = true;
  //     answers.forEach(answer => {
  //         response.data.list.forEach(question => {
  //             if (answer.questionId === question.id
  //                 && answer.answerOptions
  //                 && answer.answerOptions[0].questionOptionId) {
  //                 question.questionOptions.forEach(questionOption => {
  //                     if (parseInt(answer.answerOptions[0].questionOptionId) === questionOption.id) {
  //                         let title = questionOption.title.toUpperCase();
  //                         if (title === "JA") {
  //                             eligibleForFurtherQuestions = false;
  //                         }
  //                     }
  //                 });
  //             }
  //         });
  //     });
  //     if (eligibleForFurtherQuestions) {
  //         setProceedToNextQuestionnaire(true);
  //     }
  // };

  return (
    <>
      <Box m={1}>
        <Grid container justifyContent="flex-end" spacing={1}>
          <Grid item>
            <VaccineHistory />
          </Grid>
          <Grid item>
            <Logout />
          </Grid>
        </Grid>

        <Grid container justifyContent="center" alignItems="center" spacing={1} style={{ marginTop: 24 }}>
          <Grid
            item
            xs={12}
            style={{ display: "flex", justifyContent: "center", width: "100%" }}
          >
            <Paper style={centeredPaperStyle}>
              <Box p={2}>
                <Typography
                  variant="body2"
                  component="h1"
                  align="center"
                  style={{ fontWeight: 600, fontSize: "0.95rem" }}
                >
                  Samtidig HPV-vaccination och cellprovtagning mot
                  livmoderhalscancer
                </Typography>

                <Box
                  mt={2}
                  pt={2}
                  style={{ borderTop: "1px solid rgba(0, 0, 0, 0.08)" }}
                >
                  {response.status &&
                  response.data.list &&
                  response.data.list.length > 0 ? (
                    <>
                      <Question
                        question={response.data.list[currentQuestionIndex]}
                        saveAnswer={saveAnswer}
                        defaultAnswer={currentQuestionAnswer}
                      />
                      <Box pt={2}>
                        <Grid container spacing={1}>
                          {currentQuestionIndex !== 0 ? (
                            <Grid item xs={6}>
                              <Button
                                fullWidth
                                disableElevation
                                variant="outlined"
                                color="primary"
                                className={actionButtonClasses.actionButton}
                                onClick={handleNavigatePrevious}
                              >
                                Föregående
                              </Button>
                            </Grid>
                          ) : null}
                          <Grid item xs={currentQuestionIndex !== 0 ? 6 : 12}>
                            <Button
                              fullWidth
                              disableElevation
                              variant="contained"
                              color="primary"
                              className={actionButtonClasses.actionButton}
                              onClick={handleNavigateNext}
                            >
                              {response.data.list.length - 1 !==
                              currentQuestionIndex
                                ? "Nästa"
                                : "Slutför"}
                            </Button>
                          </Grid>
                        </Grid>
                      </Box>
                      <Box pt={2} textAlign="center">
                        <Typography variant="caption" color="textSecondary">
                          {currentQuestionIndex + 1} /{" "}
                          {response.data.list.length}
                        </Typography>
                      </Box>
                    </>
                  ) : (
                    <Box py={2}>
                      <Typography variant="body2" color="textSecondary">
                        Ingen mera frågor.
                      </Typography>
                    </Box>
                  )}
                </Box>
              </Box>
            </Paper>
          </Grid>
        </Grid>
        <Grid container justifyContent="center">
          <Grid item>
            <Copyright />
          </Grid>
        </Grid>
      </Box>

      {loader}
      {alert}

      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="sm"
        fullWidth
        PaperProps={dialogPaperProps}
      >
        <DialogTitle id="alert-dialog-title" disableTypography>
          <Typography variant="body2" component="span" style={{ fontWeight: 600 }}>
            Bekräftelse
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Typography variant="body2" color="textSecondary" id="alert-dialog-description">
            Är du säker på att du vill skicka in dina svar?
          </Typography>
        </DialogContent>
        <DialogActions style={{ padding: "16px 24px 24px" }}>
          <Button onClick={handleClose} color="secondary" className={actionButtonClasses.actionButton}>
            Nej
          </Button>
          <Button onClick={submitAnswer} color="primary" autoFocus className={actionButtonClasses.actionButton}>
            JA
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openThankYou}
        onClose={handleCloseThankYou}
        aria-labelledby="thank-you-dialog-title"
        aria-describedby="thank-you-dialog-description"
        maxWidth="sm"
        fullWidth
        PaperProps={dialogPaperProps}
      >
        <DialogTitle id="thank-you-dialog-title" disableTypography>
          <Typography variant="body2" component="span" style={{ fontWeight: 600 }}>
            Tack
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Typography variant="body2" color="textSecondary" id="thank-you-dialog-description">
            {thankYouText}
          </Typography>
        </DialogContent>
        <DialogActions style={{ padding: "16px 24px 24px" }}>
          <Button onClick={handleCloseThankYou} color="primary" className={actionButtonClasses.actionButton}>
            OK
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
